<template>
    <el-dialog
            @close="cancelAdd"
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left"
        >
        <el-form :model="dataForm" :rules="rules" ref="dataForm"
                 label-width="80px">

            <el-row>
<!--                <el-form-item label="所属大队" prop="ssdd">-->
<!--                    <el-input v-model="dataForm.ssdd"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="所属大队" prop="ssdd">
                    <el-select
                            clearable
                            filterable
                            @change="selectChangedSsdd"
                            v-model="dataForm.ssddid"
                            placeholder="请选择大队"
                    >
                        <el-option
                                v-for="item in depts"
                                :key="item.bmid"
                                :label="item.bmmc"
                                :value="item.bmid"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="岗位名称" prop="gwmc">
                    <el-input v-model="dataForm.gwmc"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="限定人数" prop="xdrs">
<!--                    <el-input v-model="dataForm.xdrs"></el-input>-->
                    <el-input-number v-model="dataForm.xdrs" :min="0" label="描述文字"></el-input-number>
                </el-form-item>
            </el-row>
<!--            <el-row>-->
<!--                <el-form-item label="实际人数" prop="sjrs">-->
<!--                    <el-input disabled="true" v-model="dataForm.sjrs"></el-input>-->
<!--                </el-form-item>-->
<!--            </el-row>-->


        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="cancelAdd()">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import FileUpload from "@/components/FileUpload/index";
    export default {
        components: {FileUpload},
        data() {
            const validateNumber = (rule, value, callback) => {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(value)) {
                    callback(new Error('请填写数字'))
                } else {
                    callback()
                }
            }
            return {
                depts:[],
                form: {
                    name: '',
                    dept:'',
                },
                equips: [],
                approvers: [],
                loading1: false,
                //表单验证规则
                rules: {
                    ssdd: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入所属大队',
                    }],
                    gwmc: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入岗位名称',
                    }],
                    xdrs: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入限定人数',
                    }],
                    // sjrs: [{
                    //     required: true,
                    //     trigger: 'blur',
                    //     message: '请输入实际人数',
                    // }]
                },
                credentials: [],
                loading: false,
                visible: false,
                useridList: [],
                menuList: [],
                customerList: [],
                dataForm: {
                    xdrs:0
                },
                types: [],
                fileList: [],
                fileListString: [],
                dialogVisible: false,
                dialogImageUrl: '',
                currentPage: 1,
                total: 0,
                uploadUrl: '',
                dataListSelections: [],
                dataRule: {
                    xm: [
                        {required: true, message: '请选择用户', trigger: 'blur'}
                    ],
                    xb: [{
                        required: true,
                        trigger: 'blur',
                        message: '请选择类型',
                    }],
                    zjhm: [
                        // { required: false, trigger: 'blur', validator: cardIdNo }
                        // { required: true,message: "证件号码不能为空",trigger: 'blur'}
                        {required: true,validator: this.cardIdNo,trigger: 'blur'}
                    ],
                }
            }
        },
        created(){
            debugger
            this.getDepts()
        },
        methods: {
            selectChangedSsdd(e){
                for (let i=0;i<this.depts.length;i++){
                    if(this.depts[i].bmid==e){
                        debugger
                        this.dataForm.ssddid = this.depts[i].bmid
                        this.dataForm.ssdd = this.depts[i].bmmc
                    }
                }
            },
            async cardIdNo(rule, value, callback){
                if(value){
                    let reg = /((^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$))/;
                    if (!reg.test(value)) {
                        callback(new Error('请输入正确格式的身份证号'));
                    } else {
                        await this.go(value.length)
                        callback();
                    }
                }else{
                    callback(new Error('身份证号不能为空'));
                    // callback();
                }

            },
            getDepts() {
                let that = this;
                this.$request
                    .get("/bjba/kqtj/getFirstMentForUser", {
                        params: {
                            userid: this.$store.getters.username,
                        },
                    })
                    .then((res) => {
                        that.depts = res.data;
                    });
            },
            cancelAdd() {
                debugger
                this.visible = false;
                this.fileList = []
                this.dataForm = {}
            },
            init() {
                // let _this =this
                // this.dataForm.id = id
                this.visible = true
                this.getDepts()
                // this.$nextTick(() => {
                //     this.getCredentials()
                //   console.log('11111111111111111111')
                //   this.$refs['dataForm'].resetFields()
                //   this.useridList=[]
                //   this.fileList=[]
                //   this.approvers=[]
                //   this.equips=[]
                //   this.dataListSelections=[]
                //   if(this.dataForm.id) {
                //     this.$http({
                //       url: '/bjba/bmry/info/'+this.dataForm.id,
                //       method: 'get'
                //     }).then(({data}) => {
                //       debugger
                //       _this.dataForm = data.data;
                //       // this.dataForm.id    = data.data.id
                //       // this.dataForm.id  = data.data.id
                //       // this.dataForm.credentialId = data.data.credentialId
                //       // this.dataForm.time = data.data.time
                //       // var user = {id:data.data.userId,xm:data.data.xm}
                //       // this.approvers.push(user)
                //       // if (data.data.urls) {
                //       //   let filelist = data.data.urls.map(e=>{
                //       //     return {url:e}
                //       //   })
                //       //   this.fileList = filelist
                //       // }
                //     })
                //   }
                // })

            },
            // 表单提交
            dataFormSubmit() {
                debugger
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        // this.dataForm.datils =
                        this.$http({
                            url: '/bjba/gwgl/update',
                            method: 'post',
                            data: this.dataForm
                        }).then(({data}) => {
                            if (data && data.code === 200) {
                                debugger
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500
                                })
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else if (data && data.code === 500) {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        })


                    }
                })
            },
            fileListChange(fileList) {
                debugger
                this.fileList = fileList
            },
            handlePictureCardPreview(file) {
                this.dialogVisible = true
                this.dialogImageUrl = file.url
            },
            handleRemove(file, fileList) {
                this.fileList.splice(this.fileList.findIndex(e => e.uid === file.uid), 1)
                if (file.url && !this.dataForm.id) {
                    this.$request({
                        method: 'post',
                        url: '/bjba/fileupload/delete',
                        params: {url: file.url}
                    }).then(res => {
                        console.log(res.data)
                    })
                }
            },
            httpRequest(data) {
                let _that = this;
                let rd = new FileReader(); // 创建文件读取对象
                let file = data.file;
                let formData = new FormData();
                formData.append('file', file);
                this.$request({
                    method: 'post',
                    url: '/bjba/fileupload/upload',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then(res => {
                    console.log(res.data)
                    this.fileList.push({url: res.data.url})
                })
            },
            getCredentials() {
                let that = this;
                this.$request.get('/bjba/credentials/findAll').then(res => {
                    this.credentials = res.data.data
                })
            },
            searchChecker1(query) {
                console.log(query)
                if (query !== '') {
                    this.loading1 = true;

                    this.$request.get('/bjba/yhgl/findUserListByxm', {
                        params: {
                            xm: query
                        }

                    }).then(res => {
                        this.loading1 = false
                        this.approvers = res.data.data

                    })
                } else {
                    this.approvers = [];
                }
            },
            // 实现自动生成生日，性别，年龄
            go(val) {
                debugger
                let iden = this.dataForm.zjhm;
                let sex = null;
                let birth = null;
                let myDate = new Date();
                let month = myDate.getMonth() + 1;
                let day = myDate.getDate();
                let age = 0;

                if (val === 18) {
                    // age = myDate.getFullYear() - iden.substring(6, 10) - 1;
                    sex = iden.substring(16, 17);
                    birth = iden.substring(6, 10) + "-" + iden.substring(10, 12) + "-" + iden.substring(12, 14);
                    // if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;

                }
                if (val === 15) {
                    // age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
                    sex = iden.substring(13, 14);
                    birth = "19" + iden.substring(6, 8) + "-" + iden.substring(8, 10) + "-" + iden.substring(10, 12);
                    // if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
                }

                if (sex % 2 === 0)
                    sex = '0';
                else
                    sex = '1';
                //性别  ==> 1:男       0:女
                // this.form.sex = sex;
                // this.form.age = age;
                this.dataForm.xb= sex;
                this.dataForm.csrq = birth;
            },
        }
    }
</script>
